<template>
  <div class="user-management-table">
    <!-- Filters use compact responsive columns so they fit beside the table at 1280x800. -->
    <b-row class="align-items-end mb-2 filters-row">
      <!-- batch selector -->
      <b-col cols="12" sm="6" lg="3" class="filter-col">
        <label for="intake-filter"><b>Select Batch:</b></label>
        <b-form-select
          id="Batch-filter"
          v-model="selectedBatch"
          :options="['B03', 'B04', 'B05', 'B06', 'B07', 'B08']"
          :placeholder="'Select a batch'"
        />
      </b-col>
      <!-- Intake selector -->
      <b-col cols="12" sm="6" lg="3" class="filter-col">
        <label for="intake-filter"><b>Select Intake:</b></label>
        <b-form-select
          id="intake-filter"
          v-model="selectedIntake"
          :options="['01', '02']"
          :placeholder="'Select an intake'"
        />
      </b-col>
      <!-- Active Status Filter -->
      <b-col cols="12" sm="6" lg="3" class="filter-col">
        <label for="active-status-filter"><b>Active Status:</b></label>
        <b-form-select
          id="active-status-filter"
          v-model="selectedActiveStatus"
          :options="['Active', 'Disabled']"
          :placeholder="'Select Active Status'"
        />
      </b-col>
      <!-- reset Button for filter -->
      <b-col cols="auto" class="filter-col">
        <b-button
          variant="success"
          class="reset-filter-btn d-flex align-items-center justify-content-center"
          @click="clearFilters()"
        >
          <feather-icon icon="RotateCcwIcon" size="18"
        /></b-button>
      </b-col>
    </b-row>
    <!-- Table is wrapped so wide user columns scroll inside the card, not the whole page. -->
    <b-card class="users-card" body-class="p-0">
      <!-- if data not empty -->
      <div v-if="users.length !== 0" class="table-wrapper">
        <b-table
          :items="filteredUsers"
          :fields="fields"
          class="users-table mb-0"
          :tbody-tr-class="rowClass"
        >
          <template #cell(date_of_birth)="data">
            <span>{{ formatDateOfBirth(data.value) }}</span>
          </template>

          <template #cell(gender)="data">
            <span v-if="data.value">{{ data.value }}</span>
            <span v-else>N/A</span>
          </template>

          <template #cell(payment_type)="data">
            <span v-if="data.value !== null">{{ data.value }}</span>
            <span v-else>N/A</span>
          </template>

          <template #cell(installment_plan)="data">
            <span v-if="Number(data.value) === 4">4 Months</span>
            <span v-else-if="Number(data.value) === 6">6 Months</span>
            <span v-else>N/A</span>
          </template>

          <template #cell(payment_value)="data">
            <span v-if="data.value !== null">{{ data.value }}</span>
            <span v-else>N/A</span>
          </template>

          <template #cell(action)="data">
            <div
              v-if="data.item.role_name !== 'Admin'"
              class="d-flex justify-content-center"
            >
              <b-button
                variant="success"
                class="edit-user-btn"
                @click="openUpdateModal(data.item)"
              >
                <feather-icon icon="EditIcon" class="mr-25"
              /></b-button>
            </div>
          </template>
        </b-table>
      </div>

      <!-- if data empty -->
      <div v-else class="text-center py-2">
        <span class="font-weight-bold">No Result</span>
      </div>
    </b-card>

    <b-modal ref="updatemodal" hide-footer title="Update User">
      <UpdateUser :userdata="selectedItem" />
    </b-modal>
  </div>
</template>

<script>
import UpdateUser from "@/views/UserManagement/Components/UpdateUser.vue";
import {
  BModal,
  BCard,
  BTable,
  BBadge,
  BButton,
  BCol,
  BRow,
  BCardText,
  BAvatar,
  BLink,
  BContainer,
  BFormSelect,
} from "bootstrap-vue";

export default {
  name: "UserTable",
  components: {
    UpdateUser,
    BCard,
    BModal,
    BButton,
    BCol,
    BBadge,
    BAvatar,
    BTable,
    BRow,
    BContainer,
    BCardText,
    BLink,
    BFormSelect,
  },
  props: {
    users: Array,
  },
  data() {
    return {
      show: false,
      selectedBatch: null,
      selectedIntake: null,
      // Stores the selected active status filter value.
      selectedActiveStatus: null,
      selectedItem: {},
      fields: [
        // add Batch
        {
          key: "batch",
          label: "Batch",
          sortable: true,
        },
        // add intake
        {
          key: "intake",
          label: "Intake",
          sortable: true,
        },
        {
          key: "internship",
          label: "Internship",
          sortable: true,
        },

        {
          key: "min_time_perday",
          label: "Time Alocation(Per Day)",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "phone",
          label: "Phone",
          sortable: true,
        },
        {
          key: "role_name",
          label: "Role Name",
          sortable: true,
        },
        {
          key: 'gender',
          label: 'Gender',
          sortable: true,
        },
        {
          key: 'payment_type',
          label: 'Payment Type',
          sortable: true,
        },
        {
          key: 'installment_plan',
          label: 'Installment Plan',
          sortable: true,
        },
        {
          key: 'payment_value',
          label: 'Payment Value',
          sortable: true,
        },
        {
          key: "payment_value",
          label: "Payment Value",
          sortable: true,
        },
        {
          key: "due_date",
          label: "Due_date",
          sortable: true,
        },
        {
          key: "active_status",
          label: "Status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    filteredUsers() {
      return this.users.filter((user) => {
        const batchMatch = this.selectedBatch
          ? user.batch === this.selectedBatch
          : true;
        const intakeMatch = this.selectedIntake
          ? user.intake === this.selectedIntake
          : true;
        // Match selected active status only when a status is selected.
        const activeStatusMatch = this.selectedActiveStatus
          ? user.active_status === this.selectedActiveStatus
          : true;

        return batchMatch && intakeMatch && activeStatusMatch;
      });
    },
  },

  methods: {
    formatDateOfBirth(value) {
      if (!value) return "N/A";

      const [year, month, day] = value.split("T")[0].split("-");

      return `${day}/${month}/${year}`;
    },
    openUpdateModal(data) {
      this.selectedItem = data;
      this.$refs.updatemodal.show();
    },
    // for clear the filter
    clearFilters() {
      this.selectedBatch = null;
      this.selectedIntake = null;
      // Reset active status filter.
      this.selectedActiveStatus = null;

      // console.log("Reset called");
    },

    // Highlight disabled users in the table.
    rowClass(item) {
      if (!item) return "";
      return item.active_status === "Disabled" ? "disabled-user-row" : "";
    },
  },
};
</script>
<style>
.disabled-user-row {
  background-color: #f8d7da !important;
  color: #721c24;
}
</style>
